/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Logincheckemaildetail3Inputs */

const en_logincheckemaildetail3 = /** @type {(inputs: Logincheckemaildetail3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We sent a sign-in link to ${i?.email}. Click it to continue.`)
};

const pt_logincheckemaildetail3 = /** @type {(inputs: Logincheckemaildetail3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enviámos um link de acesso para ${i?.email}. Clique para continuar.`)
};

/**
* | output |
* | --- |
* | "We sent a sign-in link to {email}. Click it to continue." |
*
* @param {Logincheckemaildetail3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const logincheckemaildetail3 = /** @type {((inputs: Logincheckemaildetail3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Logincheckemaildetail3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_logincheckemaildetail3(inputs)
	return pt_logincheckemaildetail3(inputs)
});
export { logincheckemaildetail3 as "loginCheckEmailDetail" }